/**
 * The 16 person colors, carried over from the Sheet's named slots. Each is tuned to read on
 * both the light and dark backgrounds. Color always means "who"; fill level means "paid".
 */
export const PERSON_COLORS: Record<string, string> = {
  Red: "#e5484d",
  Orange: "#ee7d2b",
  Yellow: "#d9a514",
  Green: "#3a9d58",
  Blue: "#3b7ddd",
  Purple: "#8b5cd6",
  Pink: "#dd559f",
  Teal: "#18978e",
  Rose: "#e47a8b",
  Peach: "#ec9b6f",
  Sky: "#4aaee0",
  Lavender: "#9d8be3",
  Sage: "#7fa275",
  Gray: "#8690a3",
  Sand: "#c19c5f",
  Mauve: "#a8739a",
};

export function colorOf(name: string | undefined): string {
  // Any hex color works too ("#1e90ff").
  if (name && /^#[0-9a-f]{6}$/i.test(name)) return name;
  return (name && PERSON_COLORS[name]) || PERSON_COLORS.Gray!;
}
